export default[
    {
        show(row,extra){//专家添加评标报告 
            return row.shbj == "1";  
        },
        tag:"my-btn",
        type:"detail",
        text(row,extra){
            return "详情"
        },
        click(row,extra){
            var that=this;
            this.goto({
                path:"./detail",
                query:{
                    bdcode:row.bdcode,
                    bgcode:row.by5,
                    zgys:that.getQuery('zgys'),
                }
            })
        }
    },
    {
        show(row,extra){//
            return extra.dlpbbgbj != "0" && row.shbj != "1" && extra.extzbgj == '1' && row.by2 != '0' && !(extra.twostage == '1' && extra.zgys == '1');
        },
        tag:"el-button",
        type:"text",
        icon:"el-icon-help",
        text(row,extra){
            return "生成"
        },
        click(row,extra){
            this.$emit('showTemplate');
        }
    },
    {
        show(row,extra){
            return ((row.by2 != '0' && extra.dlpbbgbj != '0' && !!row.by5 == false) || extra.extzbgj != '1') && !!row.shbj == false;
        },
        tag:"el-button",
        type:"text",
        icon:"el-icon-circle-plus-outline",
        text(row,extra){
            return "添加评标报告"
        },
        click(row,extra){
            var that = this;
            this.goto({
                path:"./pbbg",
                query:{
                    bdcode:row.bdcode,
                    type:"add",
                    zbprocode:that.getQuery('zbprocode'),
                    zgys:that.getQuery('zgys'),
                }
            })
        }
    },
    {
        show(row,extra){
            return row.by2 == '0' && extra.extzbgj == '1';
        },
        tag:"my-btn",
        type:"edit",
        text(row,extra){
            return "未产生候选人。如已废标请联系专家点击终止评标"
        },
        click(row,extra){
            
        }
    },
    {
        show(row,extra){//(extra.dlpbbgbj != '0' && row.by2 != '0')全流程  extra.extzbgj != '1' 半流程
            return ((extra.dlpbbgbj != '0' && row.by2 != '0') || extra.extzbgj != '1') && row.shbj == '0';
        },
        tag:"my-btn",
        type:"edit",
        text(row,extra){
            return "修改"
        },
        click(row,extra){
            var that = this;
            this.goto({
                path:"./pbbg",
                query:{
                    bdcode:row.bdcode,
                    bgcode:row.by5,
                    type:"edit",
                    zbprocode:that.getQuery('zbprocode'),
                    zgys:that.getQuery('zgys'),
                    isXingTai:that.getQuery('isXingTai'),
                }
            })
        }
    },
    {
        show(row,extra){
            return ((extra.dlpbbgbj != '0' && row.by2 != '0') || extra.extzbgj != '1') && row.shbj == '0';
        },
        tag:"my-btn",
        type:"del",
        text(row,extra){
            return "删除"
        },
        click(row,extra){
            var that = this;
            this.$ajax({
                url:`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/delete.json`,
                type:"post",
                data:{
                    bgcode:row.by5,
                },
                callback:function(data){
                    ShowMsg('删除成功','success');
                },
                complete:function(){
                    that.$emit('reload');
                }
            })
        }
    },
    {
        show(row,extra){
            return ((extra.dlpbbgbj != '0' && row.by1 != row.bdcode && row.by2 != '0') || extra.extzbgj != '1') && row.shbj == '0' && row.by3 != '0';
        },
        tag:"el-button",
        type:"text",
        icon:"el-icon-upload2",
        text(row,extra){
            return "提交评标报告"
        },
        click(row,extra){
            var that = this;
            this.$confirm('是否确认跳过专家确认，直接提交评标报告？','提示',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
                callback:function(action){
                    if(action == 'confirm'){
                        that.$ajax({
                            url:`${that.getGetters('bidUrl')}/revision/kaibiao/pbbg/commit.json`,
                            type:"post",
                            data:{
                                bgcode:row.by5,
                            },
                            callback:function(data){
                                ShowMsg('提交成功','success')
                                that.$emit('reload')
                            }
                        })
                    }
                }
            })
            
        }
    },
    {
        show(row,extra){
            return ((extra.dlpbbgbj != '0' && row.by1 != row.bdcode && row.by2 != '0') || extra.extzbgj != '1') && row.shbj == '0' && extra.showcns == '1';
        },
        tag:"my-btn",
        type:"edit",
        text(row,extra){
            return "补充专家承诺书"
        },
        click(row,extra){
            var that = this;
            this.goto({
                path:"./letterOfCommitment",
                query:{
                    bdcode:row.bdcode,
                }
            })
        }
    },
]